import AudioTuner from "./audioTuner";
const Aubio = require("./tuner/tuner-audio");
class Audio {
  constructor(gainVal = 1) {
    this.middleA = 440;
    this.semitone = 57;
    this.bufferSize = 8192;
    this.noteStrings = [
      "C",
      "C♯",
      "D",
      "D♯",
      "E",
      "F",
      "F♯",
      "G",
      "G♯",
      "A",
      "A♯",
      "B",
    ];
    this.stream = null;
    this.initGetUserMedia();
    this.gainVal = gainVal;
  }

  initGetUserMedia() {
    window.AudioContext = window.AudioContext || window.webkitAudioContext;

    if (!window.AudioContext) {
      return console.log("AudioContext not supported.");
    }

    if (navigator.mediaDevices === undefined) {
      navigator.mediaDevices = {};
    }

    if (navigator.mediaDevices.getUserMedia === undefined) {
      navigator.mediaDevices.getUserMedia = function (constraints) {
        const getUserMedia =
          navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
        if (!getUserMedia) {
          console.log("getUserMedia is not implemented in this browser.");
        }
        return new Promise(function (resolve, reject) {
          getUserMedia.call(navigator, constraints, resolve, reject);
        });
      };
    }
  }

  startRecord() {
    const self = this;

    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then(function (stream) {
        self.stream = stream;
        let source = self.audioContext.createMediaStreamSource(stream);

        self.gainNode = self.audioContext.createGain();
        self.gainNode.gain.value = self.gainVal;

        // Connect nodes
        source.connect(self.gainNode); // Connect the source to the gain node
        self.gainNode.connect(self.analyser); // Connect gain node to the analyser
        self.analyser.connect(self.scriptProcessor); // Connect analyser to script processor
        self.scriptProcessor.connect(self.audioContext.destination); // Connect script processor to output

        self.volume = 0;

        self.scriptProcessor.addEventListener("audioprocess", function (event) {
          // Loudness meter
          var buf = event.inputBuffer.getChannelData(0);
          var bufLength = buf.length;
          var sum = 0;
          var x;

          for (var i = 0; i < bufLength; i++) {
            x = buf[i];
            sum += x * x;
          }
          var rms = Math.sqrt(sum / bufLength);

          self.volume = Math.max(rms, self.volume * 0.95);
          self.volume = self.volumeToDb(self.volume);
          // self.animateMeter(self.volume);

          // Tuner
          const frequency = self.pitchDetector.do(
            event.inputBuffer.getChannelData(0)
          );

          if (frequency && self.onNoteDetected) {
            const note = self.getNote(frequency);
            self.onNoteDetected({
              name: self.noteStrings[note % 12],
              value: note,
              octave: parseInt(note / 12),
              cents: self.getCents(frequency, note),
              frequency: frequency,
            });
          }
        });
      })
      .catch(function (error) {
        console.log(
          "Some error occured in tuner ==> ",
          error.name + ": " + error.message
        );
      });
  }

  volumeToDb(volume) {
    if (volume > 1e-7) {
      return Math.log10(volume) * 20;
    } else {
      return -50;
    }
  }

  // animateMeter(value) {
  //   let val = 125 + +value.toFixed(2);

  //   if (val > 130) val = 130;
  //   debugger;
  //   if (document.gauges[0]) document.gauges[0].value = val;
  // }

  init() {
    this.audioContext = new window.AudioContext();
    this.analyser = this.audioContext.createAnalyser();
    this.scriptProcessor = this.audioContext.createScriptProcessor(
      this.bufferSize,
      1,
      1
    );
    const self = this;
    Aubio().then(function (audio) {
      self.pitchDetector = new audio.Pitch(
        "default",
        self.bufferSize,
        1,
        self.audioContext.sampleRate
      );
      self.startRecord();
    });
  }

  getNote(frequency) {
    const note = 12 * (Math.log(frequency / this.middleA) / Math.log(2));
    return Math.round(note) + this.semitone;
  }
  getCents(frequency, note) {
    return Math.floor(
      (1200 * Math.log(frequency / this.getStandardFrequency(note))) /
        Math.log(2)
    );
  }
  getStandardFrequency(note) {
    return this.middleA * Math.pow(2, (note - this.semitone) / 12);
  }

  stop(tunerUtils) {
    tunerUtils.stopped = true;

    if (this.stream) {
      this.stream.getTracks().forEach(function (track) {
        track.stop();
        // document.gauges[0].value = 75;
      });
      this.stream = null;
      this.scriptProcessor.disconnect();
    }

    tunerUtils = new AudioTuner(tunerUtils.component);
    document.getElementById("svgPath").style.fill = "#c5a73b";
    document.querySelector(".animate-tuner").style.transform = "rotate(0deg)";
    // tunerUtils.utils.resetPianoKeys();
  }
}

export default Audio;
